export const EN = {
  message: {
    banner:
      "Due to a technical issue, all the data cannot be published. We are working on it. We apologise for the inconvenience.",
    in: "In",
    loadingText: "Loading... Please wait",
    selectCustomer: "Select a customer",
    offline: "Site under maintenance",
    refer: "Refer to terms of use",
    error: {
      userNotFound: "User not found",
      noToken: "This link is no longer valid",
    },
    alert: {
      mail: "Enable mail alert",
      sms: "Enable SMS alert",
      battery: "battery alerts",
      disclamer:
        "based on thresholds defined by Akiem Leasing and concerning locomotives fitted with Railster boxes",
      sralert: "Alert Report",
      toggleAlert:
        "By activating this option, you will receive an e-mail notification for each alert sent from MyFleetHub",
      quotation: "Quotation alert",
      quotationLabel:
        "by activating this option, you will receive an e-mai notification for each new quotation posted on MyFleetHub",
    },
    select: "Select all",
    ssoLogin: "SignIn with Azure AD",
    rgpd:
      "Akiem undertakes to respect, fairly and transparent manner, all legislation on the protection of personal data, and specifically the General" +
      "Data Protection Regulation (GDPR). We do not use cookies on this Portal. This means none of your personal data will be collected while you are logged " +
      "in to the Portal, or stored after you log out. Your specific consent will be asked in the event that you want to use the Satisfaction Survey function.",
    login: {
      welcomeFirst: "Welcome",
      welcomeSecond: "to the customer area",
      id: "Login",
      pw: "Password",
      restore: "Reset my password",
      validate: "Validate",
      errorLogin: "The password is wrong please try again",
      initMsg:
        "Please enter your password to finalize the creation of your account",
    },
    aside: {
      home: "Home",
      notice: "Terms of Use",
      logout: "Logout",
      account: "My account",
      config: "Configuration",
      profil: "Profil info",
      alert: "My alerts",
      parc: "My fleet",
      planning: "My schedule",
      detail: "My fleet details",
      geo: "Geolocate my equipment",
      board: "Dashboard",
      km: "Monitoring kilometres travelled",
      hm: "Engine Hours",
      battery: "Battery info",
      mint: "My MINT",
      magic: "Maintenance Interventions",
      history: "History",
      infoloc: "Loco information",
      attachment: "add an attachment",
      fleetcontrol: "Fleet control",
      unleased: "Unleased fleet",
      doc: "My documents",
      edl: "Statement of condition / Certificates",
      certificat: "Certificates",
      jobplan: "Maintenance due values",
      krefeldplan: "Krefeld plan",
      batterytable: "Latest battery readings",
      geofencing: "Geofencing",
      disponibility: "contractual availability",
      adminloco: "Administrate locomotives",
      admin: "Internal menu",
      locoInternal: "Create a hotline ticket",
      userlist: "Users list",
    },
    superuser: {
      profile: "Profile",
      action: "Action",
      updateprofile: "Edition",
      administrator: "Administrator",
      management: "Management",
      operational: "Operational",
      commercial: "Commercial",
      delmessage1: "You are about to request the deletion of account",
      delmessage2:
        "A message will be sent to Akiem's IT department who will delete the account.",
      delmessage3:
        "will no longer have access to the My Fleet hub customer portal. If the user wishes to re-create an account at a later date, he/she should contact his/her Service Contract manager. Would you like to continue?",
      legendmgt:
        "The management profile can consult all the portal modules. He can validate extra work.",
      legendcom:
        "The sales profile can consult all the portal modules. He cannot validate an extra work.",
      legendoper:
        "The operational profile can consult all the portal modules except « my extra work »",
    },
    geofencing: {
      select: "Please select a value",
      entry: "Entry date and time",
      exit: "Exit date and time",
      dbenergy: "Have you thought about making your DB energy declaration?",
    },
    header: {
      language: "Languages",
    },
    home: {
      team: "My Akiem dedicated team",
      name: "Name",
      firstname: "First name",
      function: "Function",
      fixphone: "Fixed line phone",
      mobilephone: "Mobile phone",
      mail: "E-mail",
      locoInfo: "Create a quick service request",
    },
    page: {
      assignment: "Assignment",
      customer: "Customer",
      portal: "Portal",
      availableLoco: "Maintained by AKIEM",
      loconumber: "Locomotive ID",
      status: "Operational status",
      available: "Available",
      maintenance: "In maintenance",
      connexionDate: "Date of last connection",
      findLocation: "Find rolling stock location",
      contractNumber: "Contract number",
      serial: "series",
      contractStatus: "Contract status",
      startDate: "Start date",
      endDate: "End date",
      delta: "By selecting a date range, you will get a plot of your journey",
      locate: "Tracking",
      titular: "Titular",
      reserve: "Reserve",
      spot: "Spot",
      performance: "Performance",
      cumulTitle: "Cumulative kilometers per locomotive",
      cumul: "Cumulative Km",
      moyMonth: "Average of KM traveled / Month",
      distance: "Distance",
      filterMsg:
        "By selecting a single locomotive, you get the layout of your route",
      availableNotice: '"Does not include notices"',
      doctype: "Document Type",
      contractType: "Contract type",
    },
    opinionGlobal: {
      opinion: "My opinion on the portal",
      opinionFirst: "My opinion",
      opinionSecond: "On the portal",
      opinionRedirectionOne: "You will be redirected to an external page,",
      opinionRedirectionTwo: "do you wish to continue ?",
      opinionClic:
        "By clicking on this link, you agree to leave this portal to access the Eval N Go platform for this satisfaction survey, " +
        "and thus consent to the processing of your personal data.",
      opinionPersonelData: "The personal data collected are as follows :",
      opinionMail: "E-mail addresses",
      opinionName: "Name",
      opinionDataTransmission:
        "Those data are only transmitted to persons authorised by Akiem, who are subject to the duty of confidentiality, " +
        "and will be kept for 1 year.",
      opinionStock:
        "It is hosted in France and will not be transmitted outside the EU.",
      opinionRules:
        "In accordance with the law in force, you have the right to control your personal data (right of access, rectification, etc.) " +
        " which you can exercise by sending an e-mail to dpo@akiem.com.",
      opinionHelp:
        "This helps us to make further progress in the way we support you and to better understand your needs, " +
        "your contribution would be a great help.",
      opinionYes: "Yes",
      opinionNo: "No",
    },
    pageKm: {
      trackingKm: "Mileage tracking",
      tableKm: "Mileage table",
      status: "Contractual status",
      serial: "Serial number",
      contract: "Contracts",
      contractnum: "Contract number",
      total: "Total distance",
      loco: "Locomotives",
      date: "Dates",
      since: "Since",
      kmNotice: '"Kilometers surveyed according to Railster data submitted " ',
    },
    pageHm: {
      title: "Diesel Engine Hours",
      lastcheck: "Latest data",
      cumulativeHm: "Cumulative engine hours",
      hm: "Engine hours",
      total: "Total engine hours consumed",
      portalReal: "Readings taken from the portal",
      maintenanceReal: "Readings taken during maintenance",
      detailHm: "Details of engine hours",
    },
    maintenance: {
      workshops: "Maintenance workshops",
    },
    pageAlert: {
      alert: "My alerts",
      inout: " LOCOMOTIVE ENTRY AND EXIT",
      serial: "On a series",
      contract: "On a contract",
      loco: "On the locs in my fleet",
      mail: "Activate mail alerts",
      sms: "Activate sms alerts",
      battery: "BATTERY ALERTS",
    },
    passwordResetPage: {
      first:
        "Please enter your username and password to complete the creation of your account",
      confirm: "password confirmation",
      pwRuleOne: "password required",
      pwRuleTwo: "minimum 8 characters",
      pwRuleThree:
        "Password must contain at least lowercase letter, one number, a special character and one uppercase letter",
      pwConfirmOne: "password confirmation is required",
      pwConfirmTwo: "Password confirmation does not match",
      pwSuccess: "Password reset with success",
      validate: "Validate",
    },
    pageNotice: {
      second:
        "The data, information and/or documents appearing on the Portal are published for information purposes only and have no contractual value.",
      third:
        "The data, information and/or documents may contain inaccuracies and errors. They may be amended by Akiem at any time, and may be updated. " +
        "You are strongly recommended to verify the accuracy and relevance of data, information and/or documents available on this Portal.",
      fourty:
        "The User alone is liable for any use of data, information and/or documents available on this Portal, and accepts all of the possible " +
        "consequences of such use, for which Akiem cannot be held liable, and without any possibility of recourse against Akiem.",
      fifty:
        "Akiem may under no circumstances be held liable for any damage whatsoever arising from the interpretation or use of information and/or documents available on this Portal.",
      sixty:
        "This Portal is generally accessible 24 hours a day, 7 days a week, except in the event of force majeure or an event beyond the control " +
        "of Akiem, and subject to any breakdown or maintenance operations necessary for the proper functioning of this Portal, for Users with an internet " +
        "access. Akiem reserves the right to interrupt, at any time and without notice, temporarily suspend or modify access to all or part of the Portal, " +
        "for maintenance purposes or for any other reason, without giving right to any obligation or compensation.",
      seventy:
        "Akiem undertakes to respect, fairly and transparent manner, all legislation on the protection of personal data, particularly the General " +
        "Data Protection Regulation (GDPR). Akiem has put in place the technical and operational measures needed to ensure that Users’ data is protected from " +
        "unauthorised access and from all other risks relating to computer security and vulnerability.",
      eighty:
        "We do not use cookies on this Portal. This means none of your personal data will be collected while you are logged in to the Portal, or stored after" +
        " you log out. You will be asked for your specific consent if you wish to use the Satisfaction Survey function.",
    },
    magic: {
      workorderTitle: "Workorder title",
      workorder: "Workorder",
      startDate: "Start date",
      endDate: "End date",
      meter: "Mileage",
      hours: "Hours",
      technicDoc: "Technical documentation",
      restriction: "Restriction/Reason",
      date: "Date",
      asset: "Asset",
      km: "KM",
      leftD1: "Left D1",
      leftD2: "Left D2",
      leftD3: "Left D3",
      leftD4: "Left D4",
      rightD1: "Right D1",
      rightD2: "Right D2",
      rightD3: "Right D3",
      rightD4: "Right D4",
      action: "Action",
      description: "Summary - Location",
      desc: "Summary",
      addFile: "Add file",
      reportBy: "Report By",
      id: "ID",
      status: "Status",
      sr: "Alert",
      srAttechement: "alerts linked",
      attachements: "Attachments",
      mileage: "Usage data",
      createAlert: "Create an alert",
      title: "Title",
      location: "Location",
      priority: "Priority",
      addKm: "Communicate a usage",
      newKm: "New value",
      lastreading: "Actual Value",
      scheduleDate: "Schedule date",
      metername: "Metername",
      executeDate: "Execute date",
      error: "Operation failed",
      success: "Successful operation",
      unit: "Unit",
      source: "Source",
      jobplan: "Job plan type",
      type: "Type",
      reportedDate: "Reported date",
      details: "Details",
      hotline: "Hotline ticket",
    },
    assetStatus: {
      operating: "Operating",
      maintenance: "Maintenance",
      limitedUse: "limited use",
      blocked: "Blocked",
    },
    button: {
      submit: "Validate",
      cancel: "Cancel",
    },
    search: "Search",
    history: {
      pm: "History of preventive work order",
      cm: "History of corrective work order",
    },
    infoloc: {
      infoOp: "Operational information",
      infoTech: "Technical information",
      cert: "Certifications",
      openSr: "Open service request",
      sr: "recorded alerts",
      dateAndKm: "Date and mileage",
      pmPlan: "Preventive maintenance plan",
      locomotive: "Locomotive",
      actWorkorder: "Ongoing Work order",
      outPrevDate: "Expected release date",
      nextWorkDate: "Next maintenance plan",
      wheelset: "WHEELSET INFORMATION",
      unitToGo: "Remaining kilometers",
      engineeringvariant: "Engineering variant",
      softwareversion: "Software version",
      hkm: "mileage history",
      hhm: "engine hours history",
      fuellevel: "Fioul level",
      parking: "Parking",
      traction: "Traction",
      vehicle: "Vehicle",
      poweron: "Poweron",
      standby: "Standby",
    },
    status: {
      approved: "Confirmed appointment",
      canceled: "Cancelled",
      ccanceled: "Appointment canceled by customer",
      completed: "Status according desicion ECM 3",
      inprogress: "Under maintenance",
      wait: "forcast planing, upcoming maintenance",
      new: "New",
      sinprogress: "In progress",
      closed: "Closed",
    },
    woStatus: {
      WSCH: "Waiting to be scheduled",
      WAPPR: "Waiting to be scheduled",
      WPCOND: "Waiting to be scheduled",
      CLOSE: "Done",
      COMP: "Done",
      INPRG: "Under maintenance",
      REVIEWED: "Done/ In waiting for ECM3 release",
      WCOE: "In waiting for cost or material",
      WMATL: "In waiting for cost or material",
      APPR: "Approved",
      CA: "Cancelled",
      NOTPERF: "Not performed",
      CAN: "Cancelled",
    },
    doc: {
      certificat: {
        delivry: "DELIVERY CERTIFICATE",
        redelivry: "REDELIVERY CERTIFICATE",
        genralInfo: "GENERAL INFORMATION",
        technicalInfo: "TECHNICAL DATA",
        signature:"SIGNATURES",
        asOf:"As of ",
        andAccording: "and in accordance with the provisions",
        contractRes: "LEASE CONFIRMATION/booking* ",
        representBy:"Akiem SAS, (a French “Société par Actions simplifiée), hereinafter the LESSOR, represented by Sebastian Rodriguez",
        delivryTo: "handed over to the company ",
        society:" the company",
        lessee: " (hereinafter the LESSEE) ",
        delivryToAkm:"has delivered to Akiem represented by Sebastian Rodriguez ",
        locomotive: "the locomotive",
        locoType: "type",
        delivryAt: "delivered to the Place of Delivery of ",
        redelivryAt:"redelivered to the Place of Redelivery of:",
        restDerog:"Restrictions/ limited used",
        comment:"Comments",
        edl:"Inventory of the locomotive attached in Appendix [yes/no]",
        remark:"Note",
        rem1:"Subject to contractual provisions, this locomotive must be insured from the Delivery Date shown on the Delivrey Certificate at the latest.",
        rem2:"*Custody of the locomotive is transferred to the LESSEE on the Delivery Date stated in this Delivery Certificate.",
        kmCompteur: "Km odometer",
        hmMoteur: "Engine hours",
        wheelset: "Axles",
        recentData: "most recent specifications*",
        subjectTo: "*Subject to the inventory of the locomotive, if available.",
        lastRecord: "last recorded on ",
        date:"Date",
        defaultMes:"If no reservation is received within 48 hours, this certificate will be considered final.",
        addBill:"Additional costs for the restoration of the locomotive may be charged to the LESSEE.",
        yes: "YES",
        no: "NO",
        reserv: "To send a reserve",
        reject: "Reserves issued"
      },
      type: "Document type",
      edl: {
        delivry: "Locomotive inventory for delivery ",
        redelivry: "Locomotive inventory for redelivery ",
      },
    },
    doctypes: [
      {
        key: "DELIVERY (EXCEPT NEW)",
        value: "Locomotive inventory for delivery",
      },
      {
        key: "REDELIVERY,RESTITUTION",
        value: "Locomotive inventory for redelivery",
      },
      {
        key: "Prima Delivery Certificate,Traxx Delivery Certificate",
        value: "Delivery certificate",
      },
      {
        key: "Prima Redelivery Certificate,Traxx Redelivery Certificate",
        value: "Redelivery certificate",
      },
    ],
    poi: {
      workshop: "Entrance/Exit Workshop",
      entry: "Estimated entry on",
      exit: "Exit estimated on",
      at: "at",
    },
    extrawork: {
      title: "My Extra-works",
      newquote: "New quotations",
      quotewaiting: "Awaiting validation",
      messageconfirm: "Please enter your order number",
      confirm: "Confirm",
      reject: "Contest",
      cancel: "Cancel",
      whyreject: "Why do you wish to reject the quotation?",
      rejectcomment: "Please leave a comment",
      quotenum: "Quotation no.",
      quotetitle: "Quotation title",
      quoteprice: "Price excl.",
      quotestatus: "Quotation status",
      realisationdate: "Actual realization",
      customerpo: "Customer Po",
      tovalidate: "Awaiting validation",
      validated: "Accepted",
      rejected: "Rejected",
      quoterejected: "Rejected",
      quotesrejected: "Rejected quotes",
      comment: "Comment",
      unitprice: "Unit prices",
      service: "Services",
      quantity: "Quantity",
      totalprice: "Total price",
      quotetotalprice: "Total cost of quotation",
      statusbilled: "billed",
      statusvalidated: "validated",
    },
    dispoc: {
      past: "Passed assignement view",
      widgetText: "Check my fleet availability",
      taux: "Rate",
      recapLoc: "Availability",
      ticmp: "Preventive downtime rate",
      timcc: "Corrective downtime rate",
      ticc: "Customer downtime rate",
      locDisp: "Available",
      locTot: "Total",
      week: "Week",
      ldispo: "Available",
      ldmd: "Available in degraded mode",
      lmp: "Preventive maintenance",
      lmc: "Corrective maintenance",
      lach: "Routing",
      lmcc: "Customer corrective maintenance",
      indisponibilite: "Unavailability",
      dispGen: "Global availability",
      causeCorrective: "corrective maintenance",
      causePreventive: "preventive maintenance",
      causeClient: "customer",
    },
    restriction: {
      title: "Restriction in",
      partial: "Partial restriciton",
      total: "Total restriction",
      dates: "From {start} to {end}",
    },
  },
  country: {
    AT: "Austria",
    BE: "Belgium",
    CH: "Switzerland",
    CZ: "Czech republic",
    DE: "Germany",
    DK: "Denmark",
    FR: "France",
    HR: "Croatia",
    HU: "Hungary",
    IT: "Italy",
    LU: "Luxembourg",
    MA: "Morocco",
    NL: "Netherlands",
    PL: "Poland",
    RO: "Romania",
    SE: "Sweden",
    SK: "Slovakia",
    SI: "Slovenia",
    RS: "Serbia",
  },
};

export default EN;
